import i18n from 'src/locales/i18n';

export function getErrorMessage(error) {
  if (typeof error === 'string' && error) return error;

  const backendMessage = error?.response?.data?.errorMessages?.[0] ?? error?.errorMessages?.[0];
  if (backendMessage) return backendMessage;

  const statusCode =
    error?.response?.status ?? error?.response?.data?.statusCode ?? error?.statusCode;

  return statusCode >= 500
    ? i18n.t('common:message.server_error')
    : i18n.t('common:message.try_again');
}
